import React from 'react';
import Logo from '../svg/LogoV0'; //Logo;

function LogoSection() {
  return (
    <div>
      <Logo style={{ zoom: 0.55, marginLeft: 20, paddingBottom: 50, paddingTop: 10 }} color={'white'} />
    </div>
  )

}

export default LogoSection;
